export const UFOSegmentNames = {
	ProjectPicker: 'townsquare-project-picker',
	ProjectPickerLoading: 'townsquare-project-picker-loading',
	RecentProjectsLoading: 'townsquare-project-picker-recent-projects-loading',
	ProjectAdminAccessCheckLoading: 'townsquare-project-admin-access-check-loading',
} as const;
